import type { TranscriptSegmentData } from '@/lib/recordings/parse-transcript';

/**
 * Index of the segment whose `[start_ms, end_ms)` contains `playheadMs`.
 * Returns -1 when paused (`null`) or there are no segments. When the playhead
 * is past the last segment's end, returns the last index (so the tail stays
 * highlighted rather than dropping selection).
 */
export function activeSegmentIndex(
  segments: TranscriptSegmentData[],
  playheadMs: number | null,
): number {
  if (playheadMs == null || segments.length === 0) return -1;
  for (let i = 0; i < segments.length; i += 1) {
    const s = segments[i];
    if (playheadMs >= s.start_ms && playheadMs < s.end_ms) return i;
  }
  // Past the end → keep the last segment active.
  const last = segments[segments.length - 1];
  if (playheadMs >= last.end_ms) return segments.length - 1;
  return -1;
}
